import React from 'react'
import { Form, Pagination } from 'react-bootstrap'

const CustomPagination = props => (
  <Pagination className="justify-content-sm-end justify-content-start align-items-center flex-wrap px-md-4 px-2">
    <small className="m-0 mr-2">
      Filas por página:
    </small>
    <Form.Control
      style={{ width: '3.5rem' }}
      as="select"
      size="sm"
      value={ props.limit }
      onChange={ e => props.onChangeLimit(e.target.value) }>
      <option value="10">10</option>
      <option value="20">20</option>
      <option value="30">30</option>
      <option value="50">50</option>
      <option value="100">100</option>
      <option value="150">150</option>
      <option value="250">250</option>
      <option value="500">500</option>
    </Form.Control>
    <small className="m-0 mx-2">
      { 
        `${ String(props.offset) + '-' + String((props.currentPage  * parseInt(props.limit)) > props.dataLenght ? props.dataLenght: (props.currentPage  * parseInt(props.limit)))} de ${ props.dataLenght}`
      }
    </small>
    <Pagination.First
      className="custom-pagination-button-first"
      disabled={ props.currentPage === 1 || props.pages === 1 }
      onClick={ () => props.first() } />
    <Pagination.Item
      onClick={ () => props.prev() } 
      disabled={props.currentPage === 1 || props.pages === 1}>
        Anterior
    </Pagination.Item>
    <Pagination.Item 
      disabled={props.currentPage === props.pages || props.pages === 1 || props.pages === 0 }
      onClick={ () => props.next() }>
      Siguiente
    </Pagination.Item>
    <Pagination.Last
      className="custom-pagination-button-last"
      disabled={ props.currentPage === props.pages || props.pages === 1 || props.pages === 0 }
      onClick={ () => props.last() } />
  </Pagination>
)

export default CustomPagination
